import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { PanelGroup } from 'react-bootstrap';

import AccordionItem from './AccordionItem';

const AccordionContent = ({ items }) => {
	const [activeKey, setActiveKey] = useState(items[0].id);

	return (
		<PanelGroup
			accordion
			activeKey={activeKey}
			onSelect={(key) => setActiveKey(key)}
			id="accordion"
		>
			{items?.map((item) => (
				<AccordionItem
					key={item.id}
					id={item.id}
					title={item.title}
					content={item.content}
					isActive={activeKey === item.id}
				/>
			))}
		</PanelGroup>
	);
};

AccordionContent.propTypes = {
	items: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string,
			title: PropTypes.string.isRequired,
			content: PropTypes.node.isRequired
		})
	).isRequired
};

export default AccordionContent;
